<template>
<q-page class="main">
  <q-card class="page-card">
    <q-card-section class="page-card__main-content">
      <item-header :item="object">
        <template v-slot:header>
          <h1 class="heading-2 q-mb-lg">{{ object.title }}</h1>
        </template>
      </item-header>

      <common-banner v-if="object.deleted_at" type="warning" class="q-mb-lg">
        Dit inrichtingselement is gearchiveerd en kan niet worden gevonden via de
        zoektool.
        <template v-slot:actions>
          <q-btn color="warning" text-color="text-base" unelevated no-caps @click="restoreObject">
            Herstel het inrichtingselement
          </q-btn>
        </template>
      </common-banner>

      <object-info :item="object" />
    </q-card-section>
    <q-card-section class="page-card__details">
      <expansion-element
          label="Documenten"
          :items-count="object.assets.length"
          showEmpty>
        <document-list
            :documents="object.assets"
            :uploadUrl="$route('object.add_file', [object.id])"
            :deleteUrl="$route('object.delete_file',  [object.id])"
            :can-edit="$can('edit', object)"
        />
      </expansion-element>
      <expansion-element
          label="Categorieën"
          :items-count="categoriesCount"
      >
        <chip-list :items="object.categories" />
      </expansion-element>
    </q-card-section>
  </q-card>
  <sticky-top-bar />
  <sticky-bottom-bar v-if="!object.deleted_at && $can('edit', object)">
    <common-fab label="Bewerken" icon="edit" @click="editObject" />
  </sticky-bottom-bar>
</q-page>
</template>

<script>
import ChipList from '~HIOR/components/lists/ChipList'
import DocumentList from '~HIOR/components/lists/DocumentList'
import ObjectInfo from './ObjectInfo'

export default {
  components: {
    ChipList,
    ObjectInfo,
    DocumentList
  },
  props: {
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    categoriesCount () {
      return this.object.categories ? this.object.categories.length : null
    }
  },
  methods: {
    editObject () {
      this.$goto('object.edit', { object: this.object.id })
    },
    restoreObject () {
      this.$goto('object.restore', { object: this.object.id })
    }
  }
}
</script>
